import { forwardRef } from "react";
import { useId } from "react";
function SvgRawGoogleClassroomIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={18}
        height={18}
        x={3}
        y={3}
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={1}
      />
      <path
        fill="#1D1D1D"
        d="M12 18h6v3h-6zM9 13.72a1 1 0 0 1 .684-.948L12 12l2.316.772a1 1 0 0 1 .684.949v2.029a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-2.03Z"
      />
      <circle cx={12} cy={9} r={2} fill="#1D1D1D" />
      <path
        fill="#1D1D1D"
        d="M5 14.42a1 1 0 0 1 .804-.98L8 13v2.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25v-1.33Z"
      />
      <circle cx={7.5} cy={10.5} r={1.5} fill="#1D1D1D" />
      <path
        fill="#1D1D1D"
        d="M19 14.42a1 1 0 0 0-.804-.98L16 13v2.75c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-1.33Z"
      />
      <circle r={1.5} fill="#1D1D1D" transform="matrix(-1 0 0 1 16.5 10.5)" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawGoogleClassroomIcon);
export default ForwardRef;
